import { withByosImgixServerSign } from '@air/component-imgix-image';

import { type AppNode } from '../types';
import { getCompatibleImageUrl } from './getCompatibleImage';

export type ImageAppNode = Extract<AppNode, { type: 'image' }>;

export const isImageAppNode = (node: AppNode | undefined): node is ImageAppNode =>
  node !== undefined && node.type === 'image' && node.data.type === 'image';

/** Display URL for canvas image nodes: wrap/compat, then sign BYOS proxy only. */
export const getImageNodeDisplayUrl = (node: ImageAppNode): string | undefined => {
  const url = node.data.media?.image || node.data.media?.original;

  return toDisplayImageUrl(url);
};

export const toDisplayImageUrl = (url: string | undefined): string | undefined =>
  url ? withByosImgixServerSign(getCompatibleImageUrl(url)) : undefined;
